import React, {Component}  from 'react';
import { Carousel, Button, Row, Col } from 'antd';

const SchoolTemplate01 = ({data}) => {
//  let public_id = false;
//  let opt = {cnt:0};

/*
  if(data.images && data.images.resources){
    const images = fromJS(data.images.resources);
    const c = (images.count() > 3)?3:images.count();
    const sImages = images.setSize(c);

    opt = {
      images: sImages,
      cnt: c
    }
  }
*/


  return(
    <div id="template-01">
      <div className="blog-ad-template">
        <div className="ad-news">
          <div className="ad-news__recommend">
            トラトラのおすすめ学校
          </div>
          <div className="row row-all-10 justify-content-between align-items-center">
            <div className="col-lg-8">
              <div className="ad-news__title">
                <a href={data.url}>
                  {data.name}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ad-news__price is-school">
                {data.category === "business"?
                  <span><span>3ヶ月</span> {data.price}〜</span>
                  :
                  <span>{data.price}/週</span>
                }
              </div>
            </div>
          </div>
          <div className="row row-all-15">
            <div className="col-lg-4">
              <a href={data.url}>
                <img src={data.thumb} alt={data.name} />
              </a>
            </div>
            <div className="col-lg-8">
              <div className="ad-news__desc">
                <div dangerouslySetInnerHTML={{__html: data.summary}} />
              </div>
            </div>
          </div>
          <div className="row row-all-15">
            <div className="col-lg-6">
              <a href={data.url} className="btn btn-primary btn-block mb-3">学校の詳細をみる</a>
            </div>
            <div className="col-lg-6">
              <a href="/school#section-contact" className="btn btn-success btn-block mb-3">ビザ延長の相談をする</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
export default SchoolTemplate01;


// WEBPACK FOOTER //
// ./src/pages/news/components/school/SchoolTemplate01.js